/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Load_ErrorInputs */

const en_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load Hall of Fame entries.`)
};

const es_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las entradas del Salón de la fama.`)
};

const de_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame-Einträge konnten nicht geladen werden.`)
};

const zh_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法加载名人堂条目。`)
};

const ar_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر تحميل إدخالات قاعة المشاهير.`)
};

const fr_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les entrées du Temple de la renommée.`)
};

const vi_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải các mục Đại sảnh danh vọng.`)
};

const sw_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haikuweza kupakia maingizo ya Hall of Fame.`)
};

const th_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถโหลดรายการ Hall of Fame`)
};

const bs_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nije moguće učitati unose Kuće slavnih.`)
};

const ja_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`殿場の殿場を搬入できません。`)
};

const ko_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fame 항목의 홀을로드 할 수 없습니다.`)
};

const pt_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os itens do Hall da Fama.`)
};

const it_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non poteva caricare le voci di Hall of Fame.`)
};

const sv_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan inte ladda Hall of Fame-poster.`)
};

const nl_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon Hall of Fame-items niet laden.`)
};

const da_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke indlæse Hall of Fame indgange.`)
};

const nb_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klarte ikke laste Hall of Fame-oppføringer.`)
};

const fi_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei voitu ladata Hall of Fame -tiedostoja.`)
};

const pl_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie można wczytać wpisów z Galerii sław.`)
};

const ru_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить записи Зала славы.`)
};

const tr_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şöhretler Müzesi kayıtları yüklenemedi.`)
};

const hi_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हॉल ऑफ फेम प्रविष्टियों को लोड नहीं कर सका।`)
};

const id_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat memuat entri Balai Kehormatan.`)
};

const ms_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat memuatkan entri Dewan Kemasyhuran.`)
};

const cs_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nelze načíst položky Síně slávy.`)
};

const el_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν ήταν δυνατή η φόρτωση των καταχωρίσεων του Πανθέου Διασήμων.`)
};

const he_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא ניתן לטעון את רשומות היכל התהילה.`)
};

const af_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon nie Eregalery-inskrywings laai nie.`)
};

const hu_hof_load_error = /** @type {(inputs: Hof_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem sikerült betölteni a Hírességek Csarnokát.`)
};

/**
* | output |
* | --- |
* | "Could not load Hall of Fame entries." |
*
* @param {Hof_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_load_error = /** @type {((inputs?: Hof_Load_ErrorInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Load_ErrorInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_load_error(inputs)
	if (locale === "de") return de_hof_load_error(inputs)
	if (locale === "zh") return zh_hof_load_error(inputs)
	if (locale === "ar") return ar_hof_load_error(inputs)
	if (locale === "fr") return fr_hof_load_error(inputs)
	if (locale === "vi") return vi_hof_load_error(inputs)
	if (locale === "sw") return sw_hof_load_error(inputs)
	if (locale === "th") return th_hof_load_error(inputs)
	if (locale === "bs") return bs_hof_load_error(inputs)
	if (locale === "ja") return ja_hof_load_error(inputs)
	if (locale === "ko") return ko_hof_load_error(inputs)
	if (locale === "pt") return pt_hof_load_error(inputs)
	if (locale === "it") return it_hof_load_error(inputs)
	if (locale === "sv") return sv_hof_load_error(inputs)
	if (locale === "nl") return nl_hof_load_error(inputs)
	if (locale === "da") return da_hof_load_error(inputs)
	if (locale === "nb") return nb_hof_load_error(inputs)
	if (locale === "fi") return fi_hof_load_error(inputs)
	if (locale === "pl") return pl_hof_load_error(inputs)
	if (locale === "ru") return ru_hof_load_error(inputs)
	if (locale === "tr") return tr_hof_load_error(inputs)
	if (locale === "hi") return hi_hof_load_error(inputs)
	if (locale === "id") return id_hof_load_error(inputs)
	if (locale === "ms") return ms_hof_load_error(inputs)
	if (locale === "cs") return cs_hof_load_error(inputs)
	if (locale === "el") return el_hof_load_error(inputs)
	if (locale === "he") return he_hof_load_error(inputs)
	if (locale === "af") return af_hof_load_error(inputs)
	if (locale === "hu") return hu_hof_load_error(inputs)
	return en_hof_load_error(inputs)
});